import * as React from "react";
import Button from "../../Button/Button/Button.js";
/* empty css                 */
const ToggleGroup = ({ name, options, onClick, initialValue }) => {
  const [selectedOption, setSelectedOption] = React.useState(() => {
    if (initialValue !== void 0) {
      return options.find((option) => option.value === initialValue);
    }
    return void 0;
  });
  const handleClick = (option) => {
    const newSelectedOption = selectedOption?.value === option.value ? void 0 : option;
    setSelectedOption(newSelectedOption);
    onClick(newSelectedOption);
  };
  return /* @__PURE__ */ React.createElement("div", { role: "group", className: "toggle-group", "data-t": "toggle-group" }, options.map((option, index) => /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "barebones",
      className: "toggle-group__option",
      key: index,
      caption: option.label,
      onClick: () => handleClick(option),
      "aria-pressed": selectedOption?.value === option.value
    }
  )), /* @__PURE__ */ React.createElement("input", { type: "hidden", name, value: selectedOption?.value || "" }));
};
export {
  ToggleGroup as default
};
//# sourceMappingURL=ToggleGroup.js.map
